import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import { Select, message } from 'antd';
import NumberFormat from 'react-number-format';

import Moment from 'moment';

import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { allCategories, userAssociatedFacilities, downloadRadSummary } from '../../../common/services/ApiService';

import { firstBy } from "thenby";
import { groupBy } from '../../Helpers/GroupBy';

import Axios from '../../../config/axios';

import { toast } from '@rickylandino/react-messages';
import { getExamRadiologistsByFacility } from '../../../common/services/ReportService';

class RadDetailsReportModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: props.showModal,
            allFacilities: [],
            selectedFacility: '',
            availableBirads: [],
            selectedBirads: [],
            availableRads: [],
            selectedRad: '',
            selectedRads: [],
            availableExamTypes: [],
            selectedExamTypes: [],
            selectedDates: {
                startDate: null,
                endDate: null
            },
            showDetails: false,
            allCategories: [],
            examTypeOptions: []
        }

        this.alive = false;
    }

    componentDidMount() {
        this.alive = true;

        combineLatest(
            userAssociatedFacilities,
            allCategories
        ).pipe(takeWhile(() => this.alive)).subscribe(([f, allCategories]) => {
            if (f?.length > 0) {
                let selectedFacility = '';

                if (f.length === 1) {
                    selectedFacility = f[0].facilityModel.facilityID;
                }

                this.setState({
                    allFacilities: f,
                    selectedFacility,
                    allCategories,
                    loaded: true
                }, () => {
                        if (f.length === 1) {
                            this.handleFacilityChange(selectedFacility);
                        }
                });
            }
        });
    }

    componentWillUnmount() {
        this.alive = false;
    }

    handleDateChange = (dates, selectedDateRange) => {
        this.setState({
            selectedDateRange,
            dates
        });
    }

    handleFacilityChange = (selectedFacility) => {
        this.setState({
            selectedFacility,
            availableBirads: this.state.allFacilities.find(f => f.facilityModel.facilityID === selectedFacility)?.availableBirads || [],
            selectedRad: '',
            selectedBirads: [],
            selectedRads: [],
            selectedExamTypes: [],
            availableExamTypes: this.state.allFacilities.find(f => f.facilityModel.facilityID === selectedFacility)?.availableExamTypes || [],
        });

        getExamRadiologistsByFacility(selectedFacility).then(data => {
            let rads = [...data];
            if (rads.length === 0) {
                let facility = this.state.allFacilities.find(f => f.facilityModel.facilityID === selectedFacility);
                rads = facility?.availableRads || [];

                if (facility) {
                    var index = rads.findIndex(x => x.radiologistID == facility.outsideRadiologist?.radiologistID);

                    if (index === -1) {
                        rads.push(facility.outsideRadiologist);
                    }
                }
            }

            let availableExamTypes = this.state.allFacilities.find(f => f.facilityModel.facilityID === selectedFacility)?.availableExamTypes || [];

            let fet = [...availableExamTypes];
            fet.sort(firstBy("categoryID"));

            var o = groupBy(fet, 'categoryID');

            var sortedExamTypes = [];

            for (const property in o) {
                o[property].sort(
                    firstBy("examType")
                );

                sortedExamTypes.push(...o[property]);
            }

            let examTypeOptions = [];

            sortedExamTypes.forEach((type, idx) => {

                if (type.categoryID !== sortedExamTypes[idx - 1]?.categoryID) {
                    let newLabelObj = { label: this.state.allCategories?.find(cat => cat.categoryID === type.categoryID)?.description, options: [] };
                    examTypeOptions.push(newLabelObj);
                }

                let newOption = { label: type.examType, value: type.examTypeID };
                examTypeOptions[examTypeOptions.length - 1].options.push(newOption);
            });

            this.setState({
                availableRads: [...rads],
                examTypeOptions
            });
        });
        

    }

    handleBiradChange = (selectedBirads) => {
        // Check if "Select All" was just selected
        if (selectedBirads.includes("Select All") && !this.state.selectedBirads.includes("Select All")) {
            // Select all available BIRADS
            const allBirads = this.state.availableBirads.map(b => b.birads);
            this.setState({
                selectedBirads: allBirads
            });
        }
        // Check if "Select All" was deselected (removed)
        else if (!selectedBirads.includes("Select All") && this.state.selectedBirads.includes("Select All")) {
            // Clear all selections
            this.setState({
                selectedBirads: []
            });
        }
        // Check if "Select All" is currently selected but user selected/deselected individual items
        else if (this.state.selectedBirads.includes("Select All") && selectedBirads.includes("Select All")) {
            // Remove "Select All" from the selection and keep individual selections
            const filteredBirads = selectedBirads.filter(b => b !== "Select All");
            this.setState({
                selectedBirads: filteredBirads
            });
        }
        // Normal selection without "Select All"
        else {
            // Check if all individual items are now selected
            const allIndividualBirads = this.state.availableBirads.map(b => b.birads);
            const hasAllItems = allIndividualBirads.every(birad => selectedBirads.includes(birad));
            
            if (hasAllItems && allIndividualBirads.length === selectedBirads.length) {
                // All items are selected, so show "Select All" as selected too
                this.setState({
                    selectedBirads: ["Select All", ...selectedBirads]
                });
            } else {
                // Regular selection
                this.setState({
                    selectedBirads: selectedBirads
                });
            }
        }
    }

    handleRadChange = (selectedRad) => {
        this.setState({
            selectedRad
        });
    }

    handleRadsChange = (selectedRads) => {
        // Check if "Select All" was just selected
        if (selectedRads.includes("Select All") && !this.state.selectedRads.includes("Select All")) {
            // Select all available radiologists
            const allRadIds = this.state.availableRads.map(r => r.radiologistID);
            this.setState({
                selectedRads: allRadIds
            });
        }
        // Check if "Select All" was deselected (removed)
        else if (!selectedRads.includes("Select All") && this.state.selectedRads.includes("Select All")) {
            // Clear all selections
            this.setState({
                selectedRads: []
            });
        }
        // Check if "Select All" is currently selected but user selected/deselected individual items
        else if (this.state.selectedRads.includes("Select All") && selectedRads.includes("Select All")) {
            // Remove "Select All" from the selection and keep individual selections
            const filteredRads = selectedRads.filter(r => r !== "Select All");
            this.setState({
                selectedRads: filteredRads
            });
        }
        // Normal selection without "Select All"
        else {
            // Check if all individual items are now selected
            const allIndividualRads = this.state.availableRads.map(r => r.radiologistID);
            const hasAllItems = allIndividualRads.every(rad => selectedRads.includes(rad));
            
            if (hasAllItems && allIndividualRads.length === selectedRads.length) {
                // All items are selected, so show "Select All" as selected too
                this.setState({
                    selectedRads: ["Select All", ...selectedRads]
                });
            } else {
                // Regular selection
                this.setState({
                    selectedRads: selectedRads
                });
            }
        }
    }

    handleExamTypesChange = (selectedExamTypes) => {
        // Check if "Select All" was just selected
        if (selectedExamTypes.includes("Select All") && !this.state.selectedExamTypes.includes("Select All")) {
            // Select all available exam types
            const allExamTypeIds = this.state.availableExamTypes.map(et => et.examTypeID);
            this.setState({
                selectedExamTypes: allExamTypeIds
            });
        }
        // Check if "Select All" was deselected (removed)
        else if (!selectedExamTypes.includes("Select All") && this.state.selectedExamTypes.includes("Select All")) {
            // Clear all selections
            this.setState({
                selectedExamTypes: []
            });
        }
        // Check if "Select All" is currently selected but user selected/deselected individual items
        else if (this.state.selectedExamTypes.includes("Select All") && selectedExamTypes.includes("Select All")) {
            // Remove "Select All" from the selection and keep individual selections
            const filteredExamTypes = selectedExamTypes.filter(et => et !== "Select All");
            this.setState({
                selectedExamTypes: filteredExamTypes
            });
        }
        // Normal selection without "Select All"
        else {
            // Check if all individual items are now selected
            const allIndividualExamTypes = this.state.availableExamTypes.map(et => et.examTypeID);
            const hasAllItems = allIndividualExamTypes.every(examType => selectedExamTypes.includes(examType));
            
            if (hasAllItems && allIndividualExamTypes.length === selectedExamTypes.length) {
                // All items are selected, so show "Select All" as selected too
                this.setState({
                    selectedExamTypes: ["Select All", ...selectedExamTypes]
                });
            } else {
                // Regular selection
                this.setState({
                    selectedExamTypes: selectedExamTypes
                });
            }
        }
    }

    handleInputChange = () => {
        this.setState({
            showDetails: !this.state.showDetails
        });
    }

    handleClear = () => {
        this.setState({
            selectedFacility: '',
            selectedBirads: [],
            availableBirads: [],
            availableRads: [],
            selectedRad: '',
            selectedRads: [],
            selectedExamTypes: [],
            selectedDates: {
                startDate: null,
                endDate: new Date()
            }, 
            showDetails: false
        })
    }

    handleNewDateChange = (name, date) => {
        this.setState({ selectedDates: { ...this.state.selectedDates, [name]: date } });
    }

    handleSubmit = () => {

        let endDate = this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null;
        let startDate = this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null;

        if (this.state.selectedFacility
             && this.state.selectedRads.length > 0) {
            
            // Filter out "Select All" from selected values before submitting
            const radsValue = this.state.selectedRads.filter(r => r !== "Select All");
            const biradsValue = this.state.selectedBirads.filter(b => b !== "Select All");
            const examTypesValue = this.state.selectedExamTypes.filter(et => et !== "Select All");
            
            const q = Axios.defaults.baseURL + "api/RenderRadDetailsAndSummary";

            var form = document.createElement("form");
            form.target = "_blank";
            form.method = "POST";
            form.action = q;
            form.style.display = "none";

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "startDate";
            input.value = startDate;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "endDate";
            input.value = endDate;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "selectedFacility";
            input.value = this.state.selectedFacility;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "selectedRads";
            input.value = radsValue;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "selectedBirads";
            input.value = biradsValue;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "selectedExamTypes";
            input.value = examTypesValue;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "showDetails";
            input.value = this.state.showDetails;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "ianaTimezone";
            input.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
            form.appendChild(input);

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        } else {
            toast.error("Please provide at least the facility and a radiologist.");
        }
        
    }

    exportExcel = () => {
        const key = "loading";
        message.loading({ content: 'Exporting BIRADS Summary...', key, duration: 0 });
        let fileName = "rad-summary_" + Moment().format('YYYYMMDDHm') + '.xlsx';

        if (this.state.showDetails) {
            fileName = "rad-details_" + Moment().format('YYYYMMDDHm') + '.xlsx';
        }

        // Filter out "Select All" from selected values before submitting
        const radsValue = this.state.selectedRads.filter(r => r !== "Select All");
        const biradsValue = this.state.selectedBirads.filter(b => b !== "Select All");
        const examTypesValue = this.state.selectedExamTypes.filter(et => et !== "Select All");

        let radString = "";
        radsValue.forEach(rad => {
            radString += rad + ",";
        });

        radString = radString.slice(0, -1);

        let postdata = {
            fileName,
            sDate: this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null,
            eDate: this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null,
            selectedFacility: this.state.selectedFacility,
            selectedRads: [radString],
            selectedBirads: biradsValue,
            selectedExamTypes: examTypesValue,
            showDetails: this.state.showDetails,
            ianaTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }

        downloadRadSummary(postdata).then(data => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = fileName;//"File.xlsx";
            //document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);

            message.destroy(key);

            this.setState({
                downloading: false
            })
        }).catch(error => {
            console.log("Error");
        });
    }
    

    render() {

        const { Option } = Select;

        const { RangePicker } = DatePicker;

        const theme = window.sessionStorage.getItem("theme");

        return (
            <Modal size='lg' show={this.state.showModal} onHide={this.toggleModal} backdrop='static' dialogClassName={theme === 'dark' ? "dark-theme" : 'light-theme'}>
                <Modal.Header>
                    <h1>Radiologist Details and Summary</h1>
                </Modal.Header>
                <Modal.Body>
                    <div className="panel-content">
                        {this.state.loaded &&
                            <div className="row">

                            <div className="form-group col col-6">
                                <div className="form-label">Start Range</div>
                                <DatePicker
                                    onChange={(date) => this.handleNewDateChange('startDate', date)}
                                    selectsStart
                                    startDate={this.state.selectedDates.startDate}
                                    endDate={this.state.selectedDates.endDate}
                                    className="form-control-custom"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText='Start Date'
                                    selected={this.state.selectedDates.startDate && Moment(this.state.selectedDates.startDate).toDate()}
                                    customInput={
                                        <NumberFormat format="##/##/####" mask="_" />
                                    }
                                />
                            </div>
                            <div className="col col-6">
                                <div className="form-label">End Range</div>
                                <DatePicker
                                    onChange={(date) => this.handleNewDateChange('endDate', date)}
                                    selectsEnd
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    startDate={this.state.selectedDates.startDate}
                                    endDate={this.state.selectedDates.endDate}
                                    className="form-control-custom"
                                    placeholderText='End Date'
                                    selected={this.state.selectedDates.endDate && Moment(this.state.selectedDates.endDate).toDate()}
                                    customInput={
                                        <NumberFormat format="##/##/####" mask="_" />
                                    }
                                />

                            </div>

                            <div className="form-group col col-lg-6 col-12">
                                <div className="form-label">Facility <span className="color-pink">*</span></div>
                                {this.state.allFacilities.length === 1 ?
                                    <div>{this.state.allFacilities[0].facilityModel.facilityName}</div>
                                    :
                                    <Select
                                        allowClear
                                        placeholder="Please select"
                                        onChange={this.handleFacilityChange}
                                        className="form-control-custom w-100"
                                        bordered={false}
                                        value={this.state.selectedFacility}
                                        showSearch
                                        virtual={false}
                                        filterOption={(input, option) => (option.children[0] + option.children[1]).toLowerCase().includes(input.toLowerCase())}
                                    >
                                        {this.state.allFacilities.map((fac, idx) => <Option key={idx} key={fac.facilityModel.facilityID} value={fac.facilityModel.facilityID}>{fac.facilityModel.facilityNumber && fac.facilityModel.facilityNumber + " - "}{fac.facilityModel.facilityName}</Option>)}
                                    </Select>
                                }

                            </div>

                            {/*    <div className="form-group col col-lg-6 col-12">*/}
                            {/*    <div className="form-label">Facility <span className="color-pink">*</span></div>*/}
                            {/*        <Select*/}
                            {/*            allowClear*/}
                            {/*            placeholder="Please select"*/}
                            {/*            onChange={this.handleFacilityChange}*/}
                            {/*            className="form-control-custom w-100"*/}
                            {/*        bordered={false}*/}
                            {/*        value={this.state.selectedFacility}*/}
                            {/*        showSearch*/}
                            {/*        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}*/}
                            {/*        >*/}
                            {/*        {this.state.allFacilities.map((fac, idx) => <Option key={idx} key={fac.facilityModel.facilityID} value={fac.facilityModel.facilityID}>{fac.facilityModel.facilityNumber && fac.facilityModel.facilityNumber + " - "}{fac.facilityModel.facilityName}</Option>)}*/}
                            {/*        </Select>*/}
                            {/*</div>*/}

                            {/*<div className="form-group col col-lg-6 col-12">*/}
                            {/*    <div className="form-label">Radiologist <span className="color-pink">*</span></div>*/}
                            {/*    <Select*/}
                            {/*        allowClear*/}
                            {/*        placeholder="Please select"*/}
                            {/*        onChange={this.handleRadChange}*/}
                            {/*        className="form-control-custom w-100"*/}
                            {/*        bordered={false}*/}
                            {/*        value={this.state.selectedRad}*/}
                            {/*    >*/}
                            {/*        {this.state.availableRads.map((r, idx) => <Option key={r.radiologistID} value={r.radiologistID}>{r.fName} {r.lName}</Option>)}*/}
                            {/*    </Select>*/}
                            {/*</div>*/}

                            <div className="form-group col col-lg-6 col-12">
                                <div className="form-label">Radiologist <span className="color-pink">*</span></div>
                                <Select
                                    mode="multiple"
                                    maxTagCount={1}
                                    allowClear
                                    placeholder="Please select"
                                    onChange={this.handleRadsChange}
                                    className="form-control-custom w-100"
                                    bordered={false}
                                    virtual={false}
                                    value={this.state.selectedRads}
                                >
                                    <Option key="Select All" value="Select All">Select All</Option>
                                    {this.state.availableRads?.map((r, idx) => <Option key={r?.radiologistID} value={r?.radiologistID}>{r?.fName} {r?.lName}</Option>)}
                                </Select>
                            </div>

                            <div className="form-group col col-lg-6 col-12">
                                <div className="form-label">BIRADS</div>
                                <Select
                                    mode="multiple"
                                    maxTagCount={1}
                                    allowClear
                                    placeholder="Please select"
                                    onChange={this.handleBiradChange}
                                    className="form-control-custom w-100"
                                    bordered={false}
                                    virtual={false}
                                    value={this.state.selectedBirads}
                                >
                                    <Option key="Select All" value="Select All">Select All</Option>
                                    {this.state.availableBirads.map((b, idx) => <Option key={idx} key={b.birads} value={b.birads}>{b.birads}</Option>)}
                                </Select>
                            </div>

                            <div className="form-group col col-lg-6 col-12">
                                <div className="form-label">Exam Types</div>
                                <Select
                                        mode="multiple"
                                        maxTagCount={1}
                                        allowClear
                                        placeholder="Please select"
                                        onChange={this.handleExamTypesChange}
                                        className="form-control-custom w-100"
                                        bordered={false}
                                        virtual={false}
                                        value={this.state.selectedExamTypes}
                                >
                                    <Option key="Select All" value="Select All">Select All</Option>
                                    {this.state.examTypeOptions.map((group, groupIdx) => (
                                        <Select.OptGroup key={groupIdx} label={group.label}>
                                            {group.options.map((option, optIdx) => (
                                                <Option key={`${groupIdx}-${optIdx}`} value={option.value}>
                                                    {option.label}
                                                </Option>
                                            ))}
                                        </Select.OptGroup>
                                    ))}
                                </Select>
                            </div>

                            <div className="form-group col-lg-6">
                                <label className="form-label">Show Detailed Report</label>
                                <div className="form-control-custom no-border">
                                    <div className="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" className="custom-control-input" id="showDetails" name="showDetails" value={this.state.showDetails || ''} onChange={this.handleInputChange} />
                                        <label className="custom-control-label"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                            


                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-submit float-left" onClick={this.handleSubmit} style={{ left: '10px', position: 'fixed', backgroundColor: '#1D6F42', borderColor: '#1D6F42' }}>Export to PDF</button>
                    <div className="row">
                        <div className="form-group col-12 padding-25-10">
                            <button className="btn btn-submit" onClick={this.exportExcel}>Run Report</button>
                            <button className="btn btn-outline-default margin-left-15" onClick={this.handleClear}>Clear</button>
                            <button className="btn btn-outline-default margin-left-15" id="closeModal" onClick={() => this.props.hideModal()}>Cancel</button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(RadDetailsReportModal);